import { Card } from "../types/Card";

export const cards: Card[] = [
  {
    id: "1",
    communityId: "btc-isla",
    communityName: "BTC Isla",
    location: "Isla Mujeres, Mexico",
    artist: "abstractlai",
    number: "1/40",
    imageUrl: "/images/card-images/card1-40.png",
    title: "#1 - BTC Isla - abstractlai",
    description: "Donde el mar abraza la soberanía: cada satoshi es una ola de libertad.",
    orientation: "landscape", // or "portrait"
    coordinates: [
      { latitude: 21.2314, longitude: -86.7314 }, // Isla Mujeres coordinates
    ],
  },
  {
    id: "2",
    communityId: "btc-isla",
    communityName: "BTC Isla",
    location: "Isla Mujeres, Mexico",
    artist: "altafacha69",
    number: "2/40",
    imageUrl: "/images/card-images/card2-40.png",
    title: "#2 - BTC Isla - altafacha69",
    description: "Arte y autocustodia se encuentran en la isla del dinero libre.",
    orientation: "landscape", // or "portrait"
    coordinates: [
      { latitude: 21.2314, longitude: -86.7314 }, // Isla Mujeres coordinates
    ],
  },
  {
    id: "3",
    communityId: "bitcoin-nea",
    communityName: "Bitcoin NEA",
    location: "Resistencia, Chaco, Argentina",
    artist: "josediosok",
    number: "3/40",
    imageUrl: "/images/card-images/card3-40.png",
    title: "#3 - Bitcoin NEA - josediosok",
    description: "Desde el Chaco, una semilla de Bitcoin germina en cada vecino.",
    orientation: "landscape", // or "portrait"
    coordinates: [
      { latitude: -27.4518, longitude: -58.9836 }, // Chaco, Argentina coordinates
    ],
  },
  {
    id: "4",
    communityId: "satoshi-somos-todos",
    communityName: "Satoshi Somos Todos",
    location: "Santo Domingo, Republica Dominicana",
    artist: "josediosok",
    number: "4/40",
    imageUrl: "/images/card-images/card4-40.png",
    title: "#4 - Satoshi Somos Todos - josediosok",
    description: "El Caribe descubre que el verdadero tesoro no pide permiso.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "5",
    communityId: "satoshi-somos-todos",
    communityName: "Satoshi Somos Todos",
    location: "Santo Domingo, República Dominicana",
    artist: "abstractlai",
    number: "5/40",
    imageUrl: "/images/card-images/card5-40.png",
    title: "#5 - Satoshi Somos Todos - abstractlai",
    description: "Santo Domingo late al ritmo de bloques que nadie puede censurar.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "6",
    communityId: "escuelita-bitcoin",
    communityName: "Escuelita Bitcoin",
    location: "Paraguay y Montevideo, Uruguay ",
    artist: "leonelzab",
    number: "6/40",
    imageUrl: "/images/card-images/card6-40.png",
    title: "#6 - Escuelita Bitcoin - leonelzab",
    description: "Aprender Bitcoin es desaprender el miedo a ser tu propio banco.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "7",
    communityId: "cuba-bitcoin",
    communityName: "Cuba Bitcoin",
    location: "La Habana, Cuba",
    artist: "altafacha69",
    number: "7/40",
    imageUrl: "/images/card-images/card7-40.png",
    title: "#7 - Cuba Bitcoin - altafacha69",
    description: "En La Habana, la esperanza viaja por la red Lightning.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "8",
    communityId: "btc-isla",
    communityName: "BTC Isla",
    location: "Isla Mujeres, México",
    artist: "maxibellmann",
    number: "8/40",
    imageUrl: "/images/card-images/card8-40.png",
    title: "#8 - BTC Isla - maxibellmann",
    description: "Trazos abstractos para una revolución monetaria sin fronteras.",
    orientation: "landscape", // or "portrait"
    coordinates: [
      { latitude: 21.2314, longitude: -86.7314 }, // Isla Mujeres coordinates
    ],
  },
  {
    id: "9",
    communityId: "escuelita-bitcoin",
    communityName: "Escuelita Bitcoin",
    location: "Paraguay y Montevideo, Uruguay",
    artist: "altafacha69",
    number: "9/40",
    imageUrl: "/images/card-images/card9-40.png",
    title: "#9 - Escuelita Bitcoin - altafacha69",
    description: "La escuelita enseña que doce palabras valen más que mil promesas.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "10",
    communityId: "btc-x-bolivia",
    communityName: "BtcxBolivia",
    location: "La Paz, Bolivia",
    artist: "altafacha69",
    number: "10/40",
    imageUrl: "/images/card-images/card10-40.png",
    title: "#10 - BtcxBolivia - altafacha69",
    description: "Desde los Andes, Bolivia mina futuro a más de tres mil metros de altura.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "11",
    communityId: "satoshi-somos-todos",
    communityName: "Satoshi Somos Todos",
    location: "Santo Domingo, República Dominicana",
    artist: "maxibellmann",
    number: "11/40",
    imageUrl: "/images/card-images/card11-40.png",
    title: "#11 - Satoshi Somos Todos - maxibellmann",
    description: "Comunidad, código y café: el combustible de la adopción.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "12",
    communityId: "escuelita-bitcoin",
    communityName: "Escuelita Bitcoin",
    location: "Paraguay y Montevideo, Uruguay",
    artist: "valukki",
    number: "12/40",
    imageUrl: "/images/card-images/card12-40.png",
    title: "#12 - Escuelita Bitcoin - valukki",
    description: "Cada obra es un nodo más en la red de la libertad.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "13",
    communityId: "prospera-distrito-bitcoin",
    communityName: "Próspera Distrito Bitcoin",
    location: "Roatan, Honduras",
    artist: "leonelzab",
    number: "13/40",
    imageUrl: "/images/card-images/card13-40.png",
    title: "#13 - Próspera Distrito Bitcoin - leonelzab",
    description: "Próspera demuestra que una ciudad entera puede correr sobre Bitcoin.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "14",
    communityId: "prospera-distrito-bitcoin",
    communityName: "Próspera Distrito Bitcoin",
    location: "Roatan, Honduras",
    artist: "abstractlai",
    number: "14/40",
    imageUrl: "/images/card-images/card14-40.png",
    title: "#14 - Próspera Distrito Bitcoin - abstractlai",
    description: "Roatán: donde el coral y el consenso comparten el mismo azul.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "15",
    communityId: "bitcoin-berlin",
    communityName: "Bitcoin Berlín",
    location: "Berlín, El Salvador",
    artist: "josediosok",
    number: "15/40",
    imageUrl: "/images/card-images/card15-40.png",
    title: "#15 - Bitcoin Berlín - josediosok",
    description: "Berlín del trópico, capital del dinero que no se imprime.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "16",
    communityId: "club-satoshi",
    communityName: "Club Satoshi",
    location: "San Miguel de Tucumán, Tucumán, Argentina",
    artist: "leonelzab",
    number: "16/40",
    imageUrl: "/images/card-images/card16-40.png",
    title: "#16 - Club Satoshi - leonelzab",
    description: "En Tucumán, el club que cambió pesos por convicción.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "17",
    communityId: "bitcoin-berlin",
    communityName: "Bitcoin Berlín",
    location: "Berlín, El Salvador",
    artist: "altafacha69",
    number: "17/40",
    imageUrl: "/images/card-images/card17-40.png",
    title: "#17 - Bitcoin Berlín - altafacha69",
    description: "El volcán también guarda calor para las transacciones soberanas.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "18",
    communityId: "cuba-bitcoin",
    communityName: "Cuba Bitcoin",
    location: "La Habana, Cuba",
    artist: "ikbenmartuu_",
    number: "18/40",
    imageUrl: "/images/card-images/card18-40.png",
    title: "#18 - Cuba Bitcoin - ikbenmartuu_",
    description: "Martú pinta La Habana en clave de resistencia naranja.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "19",
    communityId: "bitcoin-nea",
    communityName: "Bitcoin NEA",
    location: "Resistencia, Chaco, Argentina",
    artist: "ikbenmartuu_",
    number: "19/40",
    imageUrl: "/images/card-images/card19-40.png",
    title: "#19 - Bitcoin NEA - ikbenmartuu_",
    description: "El nordeste argentino dibuja su independencia bloque a bloque.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "20",
    communityId: "club-satoshi",
    communityName: "Club Satoshi",
    location: "San Miguel de Tucumán, Tucumán, Argentina",
    artist: "petterzweil",
    number: "20/40",
    imageUrl: "/images/card-images/card20-40.png",
    title: "#20 - Club Satoshi - petterzweil",
    description: "Arte coleccionable, libertad incoleccionable.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "21",
    communityId: "lago-bitcoin",
    communityName: "Lago Bitcoin",
    location: "Lago Atitlan, Guatemala",
    artist: "josediosok",
    number: "21/40",
    imageUrl: "/images/card-images/card21-40.png",
    title: "#21 - Lago Bitcoin - josediosok",
    description: "El lago refleja un cielo sin intermediarios.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "22",
    communityId: "bitcoin-berlin",
    communityName: "Bitcoin Berlín",
    location: "Berlín, El Salvador",
    artist: "valukki",
    number: "22/40",
    imageUrl: "/images/card-images/card22-40.png",
    title: "#22 - Bitcoin Berlín - valukki",
    description: "Atitlán enseña que el valor nace del acuerdo, no del decreto.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "23",
    communityId: "club-satoshi",
    communityName: "Club Satoshi",
    location: "San Miguel de Tucumán, Tucumán, Argentina",
    artist: "msrdigitalart",
    number: "23/40",
    imageUrl: "/images/card-images/card23-40.png",
    title: "#23 - Club Satoshi - msrdigitalart",
    description: "Tucumán ilustra que el futuro se autocustodia.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "24",
    communityId: "club-satoshi",
    communityName: "Club Satoshi",
    location: "San Miguel de Tucumán, Tucumán, Argentina",
    artist: "maxibellmann",
    number: "24/40",
    imageUrl: "/images/card-images/card24-40.png",
    title: "#24 - Club Satoshi - maxibellmann",
    description: "Cada pincelada es una llave privada hacia uno mismo.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "25",
    communityId: "lago-bitcoin",
    communityName: "Lago Bitcoin",
    location: "Lago Atitlan, Guatemala",
    artist: "ikbenmartuu_",
    number: "25/40",
    imageUrl: "/images/card-images/card25-40.png",
    title: "#25 - Lago Bitcoin - ikbenmartuu_",
    description: "En las orillas del Atitlán, los satoshis fluyen como el agua.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "26",
    communityId: "bitcoin-nea",
    communityName: "Bitcoin NEA",
    location: "Resistencia, Chaco, Argentina",
    artist: "abstractlai",
    number: "26/40",
    imageUrl: "/images/card-images/card26-40.png",
    title: "#26 - Bitcoin NEA - abstractlai",
    description: "Resistencia hace honor a su nombre: dinero que no se rinde.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "27",
    communityId: "lago-bitcoin",
    communityName: "Lago Bitcoin",
    location: "Lago Atitlan, Guatemala",
    artist: "abstractlai",
    number: "27/40",
    imageUrl: "/images/card-images/card27-40.png",
    title: "#27 - Lago Bitcoin - abstractlai",
    description: "El arte recuerda que Bitcoin es para todos, incluso a la orilla del lago.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "28",
    communityId: "bitcoin-nea",
    communityName: "Bitcoin NEA",
    location: "Resistencia, Chaco, Argentina",
    artist: "valukki",
    number: "28/40",
    imageUrl: "/images/card-images/card28-40.png",
    title: "#28 - Bitcoin NEA - valukki",
    description: "NEA late fuerte: una comunidad que educa y atesora.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "29",
    communityId: "cuba-bitcoin",
    communityName: "Cuba Bitcoin",
    location: "La Habana, Cuba",
    artist: "leonelzab",
    number: "29/40",
    imageUrl: "/images/card-images/card29-40.png",
    title: "#29 - Cuba Bitcoin - leonelzab",
    description: "Cuba sueña en naranja con un futuro sin permiso.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "30",
    communityId: "escuelita-bitcoin",
    communityName: "Escuelita Bitcoin",
    location: "Paraguay y Montevideo, Uruguay",
    artist: "petterzweil",
    number: "30/40",
    imageUrl: "/images/card-images/card30-40.png",
    title: "#30 - Escuelita Bitcoin - petterzweil",
    description: "La escuelita gradúa soberanos, no clientes.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "31",
    communityId: "btc-x-bolivia",
    communityName: "BtcxBolivia",
    location: "La Paz, Bolivia",
    artist: "leonelzab",
    number: "31/40",
    imageUrl: "/images/card-images/card31-40.png",
    title: "#31 - BtcxBolivia - leonelzab",
    description: "La Paz encuentra paz en un dinero que nadie controla.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "32",
    communityId: "satoshi-somos-todos",
    communityName: "Satoshi Somos Todos",
    location: "Santo Domingo, República Dominicana",
    artist: "petterzweil",
    number: "32/40",
    imageUrl: "/images/card-images/card32-40.png",
    title: "#32 - Satoshi Somos Todos - petterzweil",
    description: "Todos somos Satoshi cuando guardamos nuestras propias llaves.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "33",
    communityId: "prospera-distrito-bitcoin",
    communityName: "Próspera Distrito Bitcoin",
    location: "Roatan, Honduras",
    artist: "josediosok",
    number: "33/40",
    imageUrl: "/images/card-images/card33-40.png",
    title: "#33 - Próspera Distrito Bitcoin - josediosok",
    description: "Próspera: prueba viviente de que la libertad escala.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "34",
    communityId: "btc-x-bolivia",
    communityName: "BtcxBolivia",
    location: "La Paz, Bolivia",
    artist: "valukki",
    number: "4/40",
    imageUrl: "/images/card-images/card34-40.png",
    title: "#34 - BtcxBolivia - valukki",
    description: "Bolivia colorea su independencia financiera a pura altura.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "35",
    communityId: "bitcoin-berlin",
    communityName: "Bitcoin Berlín",
    location: "Berlín, El Salvador",
    artist: "msrdigitalart",
    number: "35/40",
    imageUrl: "/images/card-images/card35-40.png",
    title: "#35 - Bitcoin Berlín - msrdigitalart",
    description: "Berlín salvadoreño, faro de adopción para el mundo.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "36",
    communityId: "cuba-bitcoin",
    communityName: "Cuba Bitcoin",
    location: "La Habana, Cuba",
    artist: "abstractlai",
    number: "36/40",
    imageUrl: "/images/card-images/card36-40.png",
    title: "#36 - Cuba Bitcoin - abstractlai",
    description: "En la isla mayor del Caribe, el naranja es esperanza.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "37",
    communityId: "prospera-distrito-bitcoin",
    communityName: "Próspera Distrito Bitcoin",
    location: "Roatan, Honduras",
    artist: "elsyluque54",
    number: "37/40",
    imageUrl: "/images/card-images/card37-40.png",
    title: "#37 - Próspera Distrito Bitcoin - elsyluque54",
    description: "Roatán firma con arte el futuro de Próspera.",
    orientation: "landscape", // or "portrait"
  },
  {
    id: "38",
    communityId: "btc-isla",
    communityName: "BTC Isla",
    location: "Isla Mujeres, Mexico",
    artist: "josediosok",
    number: "38/40",
    imageUrl: "/images/card-images/card38-40.png",
    title: "#38 - BTC Isla - josediosok",
    description: "Isla Mujeres: mar, sol y autocustodia en una sola postal.",
    orientation: "landscape", // or "portrait"
    coordinates: [
      { latitude: 21.2314, longitude: -86.7314 }, // Isla Mujeres coordinates
    ],
  },
  {
    id: "39",
    communityId: "btc-x-bolivia",
    communityName: "BtcxBolivia",
    location: "La Paz, Bolivia",
    artist: "petterzweil",
    number: "39/40",
    imageUrl: "/images/card-images/card39-40.png",
    title: "#39 - BtcxBolivia - petterzweil",
    description: "Desde Bolivia, el arte mina convicción en cada bloque.",
    orientation: "portrait", // or "portrait"
  },
  {
    id: "40",
    communityId: "lago-bitcoin",
    communityName: "Lago Bitcoin",
    location: "Lago Atitlan, Guatemala",
    artist: "noe21io",
    number: "40/40",
    imageUrl: "/images/card-images/card40-40.png",
    title: "#40 - Lago Bitcoin - noe21io",
    description: "El lago cierra la colección con un reflejo de libertad.",
    orientation: "portrait", // or "portrait"
  },
];

// Helper functions for filtering
export const getCardsByCommunity = (communityId: string): Card[] => {
  return cards.filter((card) => card.communityId === communityId);
};

export const getCardsByArtist = (artist: string): Card[] => {
  return cards.filter((card) => card.artist === artist);
};

export const getUniqueCommunities = (): string[] => {
  return [...new Set(cards.map((card) => card.communityName))];
};

export const getUniqueArtists = (): string[] => {
  return [...new Set(cards.map((card) => card.artist))];
};

export const getArtistsWithCardCounts = (): {
  name: string;
  count: number;
}[] => {
  const artistCounts: { [key: string]: number } = {};

  cards.forEach((card) => {
    artistCounts[card.artist] = (artistCounts[card.artist] || 0) + 1;
  });

  return Object.entries(artistCounts)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count); // Sort by count descending
};

export const getCardById = (id: string): Card | undefined => {
  return cards.find((card) => card.id === id);
};
